import { createSelector } from 'reselect'
import { List, Map } from 'immutable'

export const getProtracks = state => state.get('persist').protracks

export const getActivities = createSelector(getProtracks, protracks => protracks.get('activities'))

export const getActivitiesAll = createSelector(getActivities, activities => activities.get('all'))

export const getActivitiesLoaded = createSelector(getActivities, activities => activities.get('loaded'))

export const getActivitiesIds = createSelector(getActivities, activities => activities.get('ids'))

export const getActivitiesBeforeCreateOrder = createSelector(
  getActivities,
  activities => activities.get('beforeCreateOrder') + 1
)

export const getActivitiesList = createSelector(getActivitiesAll, getActivitiesIds, (all, ids) =>
  List(ids.map(id => all.get(id.toString())))
)

export const getActivitiesListOrdered = createSelector(getActivitiesList, list => list.sort((a, b) => a.day - b.day))

export const getActivitiesView = createSelector(getActivities, activities => activities.get('view'))

export const getActivitiesViewPresenter = createSelector(getActivitiesAll, getActivitiesView, (all, id) =>
  id ? all.get(id.toString()) : null
)

export const getActivitiesInvalid = createSelector(getActivitiesAll, activities =>
  activities.some(
    activity => (activity.get('invalid') || activity.get('isImageLinkInvalid')) && !activity.get('deleting')
  )
)

export const getActivitiesListForRequest = createSelector(getActivitiesListOrdered, list => {
  let index = 1
  return list.reduce((acc, activity) => {
    if (!activity.get('deleting')) {
      const categoryTag = activity.get('categoryTag')
      acc.push({
        ...activity.toJS(),
        pinned: !!activity.get('pinned'),
        day: index++,
        categoryTag: typeof categoryTag === 'string' ? { value: categoryTag, name: categoryTag } : categoryTag,
        id: null,
      })
    }
    return acc
  }, [])
})

export const isActivitiesTouched = createSelector(getActivities, state => state.get('touched'))

export const getCategoriesTagsListForLevelLibrary = createSelector(getActivities, state => state.get('categoriesTags'))

export const getCategoriesTagsMapForLevelLibrary = createSelector(
  getCategoriesTagsListForLevelLibrary,
  categoriesTags =>
    categoriesTags.reduce((acc, categoryTag) => {
      return acc.set(categoryTag.value, { value: categoryTag.value, name: categoryTag.name })
    }, Map())
)

export const getActivitiesWithImageLinkInvalid = createSelector(getActivitiesAll, activities =>
  activities.filter(activity => activity.get('isImageLinkInvalid'))
)
